export const NETWORKS = [
  { key: "tesla", label: "Tesla Supercharger", match: /tesla/i, logo: "/charger-logos/tesla.png" },
  { key: "ionity", label: "IONITY", match: /ionity/i, logo: "/charger-logos/ionity.png" },
  { key: "fastned", label: "Fastned", match: /fastned/i, logo: "/charger-logos/fastned.png" },
  { key: "allego", label: "Allego", match: /allego/i, logo: "/charger-logos/allego.png" },
  { key: "shell", label: "Shell Recharge", match: /shell|newmotion/i, logo: "/charger-logos/shell.png" },
  { key: "totalenergies", label: "TotalEnergies", match: /total\s?energies|total\b/i, logo: "/charger-logos/totalenergies.png" },
  { key: "enbw", label: "EnBW", match: /enbw/i, logo: "/charger-logos/enbw.png" },
  { key: "electra", label: "Electra", match: /electra/i, logo: null },
];

export const findNetwork = (operator) => {
  if (!operator) return null;
  return NETWORKS.find((n) => n.match.test(operator)) || null;
};
